import { PbhRequestStatus } from "./PbhRequestStatus";

export const GetAlternatePnStatus = [
  { Description: "Alternate Pn Accepted", Value: PbhRequestStatus.AlternatePnAccepted },
  { Description: "Alternate Pn Offered", Value: PbhRequestStatus.AlternatePnOffered },
  { Description: "Alternate Pn Rejected", Value: PbhRequestStatus.AlternatePnRejected },
];
